module.exports = __webpack_public_path__ + "img/cloud-fog-sun-2.32427d48.svg";